
import React, { useState, useEffect } from "react";
import { useNavigate, useLocation, createSearchParams } from 'react-router-dom';
import { useSelector, useDispatch } from "react-redux";
import { Paper, Grid, Dialog, DialogTitle, Typography, Button, DialogContent, Box, TextField } from "@mui/material";

import { motion, AnimatePresence } from "framer-motion/dist/framer-motion"

import FullscreenIcon from '@mui/icons-material/Fullscreen';
import { FullscreenExit, SettingsInputComponent, SettingsPowerRounded } from "@mui/icons-material";

import DropdownTreeSelect from 'react-dropdown-tree-select'
import { addGroups, admingroupsClear, admingroupsClearModify, selectAdminGroups, selectGroupSelectTree, updateGroups } from "../../../reducers/admincenter_groups";
import { LoadingButton } from "@mui/lab";

const OrganizationDisplay = () => {
    const location = useLocation()
    const navigate = useNavigate()
    const dispatch = useDispatch()

    const { user: currentUser } = useSelector((state) => state.auth);
    const ALPHA_NUMERIC_DASH_REGEX = /^[a-zA-Z0-9-_ ]+$/;

    const [errorGroupGuid, setErrorGroupGuid] = useState(false)

    const GroupCRUDStatus = useSelector(state => state.admingroups.statusModify)
    const GroupCRUDError = useSelector(state => state.admingroups.errorModify)

    const Groups = useSelector(state => selectAdminGroups(state))


    const [GroupGuid, setGroupGuid] = useState("")
    const [GroupObject, setGroupObject] = useState({})
    const [OrganizationName, setOrganizationName] = useState("")
    const [OrganizationName_Update, setOrganizationName_Update] = useState("")
    const [IsCreateGroupOpen, setIsCreateGroupOpen] = useState(false)
    const [IsEditGroupOpen, setIsEditGroupOpen] = useState(false)
    const [IsError, setIsError] = useState(false)

    const GroupTreeSelect = useSelector(state => selectGroupSelectTree(state, GroupGuid))

    const handleCloseEditDialog = () => {
        setIsEditGroupOpen(false)
    }

    const handleOpenEditDialog = () => {
        setOrganizationName_Update(GroupObject.OrganizationName || "")
        setIsEditGroupOpen(true)
    }

    const handleCloseCreateDialog = () => {
        setIsCreateGroupOpen(false)
    }

    const onChange = (currentNode, selectedNodes) => {
        setGroupGuid(currentNode.value)
        const SelectedGroup = Groups.filter(x => { return x.OrganizationId_Guid === currentNode.value })
        setGroupObject(SelectedGroup[0])
    }

    const handleNameChange = (v) => {
        setOrganizationName(v)
    }

    const handleNameChange_Update = (v) => {
        setOrganizationName_Update(v)
    }

    useEffect(() => {
        if (GroupCRUDStatus === 'success') {
            setIsError(false)
            handleCloseCreateDialog()
            handleCloseEditDialog()
            dispatch(admingroupsClear())
        } else if (GroupCRUDStatus === 'failed') {
            setIsError(true)
        }
    }, [dispatch, GroupCRUDStatus])

    const handleUpdateGroup = () => {
        dispatch(admingroupsClearModify())
        dispatch(updateGroups({
            AuthToken: currentUser.AuthToken
            , OrganizationName: OrganizationName_Update
            , OrganizationId_Guid: GroupObject.OrganizationId_Guid
            , OrganizationActiveFlag: GroupObject.OrganizationActiveFlag
        }))
    }

    const handleCreateGroup = () => {
        dispatch(admingroupsClearModify())
        dispatch(addGroups({ AuthToken: currentUser.AuthToken, OrganizationId_Guid_Parent: GroupObject.OrganizationId_Guid, OrganizationName: OrganizationName }))
    }
    ///  localhost/WsWebAppWellcomplete/build/login?g=3ea7ac4e-ba2a-4153-b141-c4c55244123e
    return (
        <Grid container direction="row" alignItems="center" justifyContent="center" spacing={2}>

            <Grid item xs={12} md={4}>
                <Box border={errorGroupGuid ? 1 : 0} sx={{ borderColor: "#f44336" }}>

                    <DropdownTreeSelect
                        data={GroupTreeSelect}
                        onChange={onChange}
                        //onAction={onAction} 
                        //onNodeToggle={onNodeToggle}  
                        className="mdl-demo"
                        texts={{ placeholder: "Select Group" }}
                        keepChildrenOnSearch={true}
                        keepTreeOnSearch={true}
                        showDropdown="always"
                    />
                </Box>
            </Grid>

            <Grid item xs={12} md={8}>
                <Box p={2}>

                    {GroupObject && GroupObject.OrganizationId_Guid && (


                        <Grid container direction="row" alignItems="center" justifyContent="center" spacing={3}>
                            <Grid item xs={12}>
                                <Typography variant="h3">{GroupObject.OrganizationName}</Typography>
                            </Grid>
                            <Grid item xs={12}>
                                <Typography variant="body1">{GroupObject.OrganizationId_Guid}</Typography>
                            </Grid>
                            <Grid item xs={12}>
                                <Typography variant="caption">{window && window.location && window.location.href ? window.location.href.replace(location.pathname, "/login?g=" + GroupObject.OrganizationId_Guid) : ""}</Typography>
                            </Grid>
                            <Grid item xs={12}>
                                <Grid container direction="row" alignItems="center" justifyContent="center" spacing={3}>
                                    <Grid item xs={6}>
                                        <Button variant="contained" color="info" onClick={() => { handleOpenEditDialog() }}>Edit Group</Button>
                                    </Grid>
                                    <Grid item xs={6}>
                                        <Button variant="contained" color="success" onClick={() => { setIsCreateGroupOpen(true) }}>Create Child Group</Button>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Grid>
                    )}
                </Box>
            </Grid>
            <Dialog open={IsCreateGroupOpen} onClose={() => { handleCloseCreateDialog() }}>
                <DialogTitle>
                    <Typography variant="h4">Create Group</Typography>
                </DialogTitle>
                <DialogContent>
                    <Grid container direction="row" alignItems="center" justifyContent="center" spacing={3}>
                        <Grid item xs={12}>
                            <TextField
                                variant="standard"
                                type="text"
                                onChange={(e) => {
                                    const value = e.target.value
                                    if (value !== "" && !ALPHA_NUMERIC_DASH_REGEX.test(value)) {
                                        return;
                                    }
                                    handleNameChange(value)
                                }} value={OrganizationName}
                                label="Group Name"
                                placeholder="Group Name"
                            />
                        </Grid>
                        <Grid item xs={6}>
                            <LoadingButton 
                                variant="contained" 
                                loading ={GroupCRUDStatus ==='loading'}
                                disabled={GroupCRUDStatus ==='loading'}
                                color="success" 
                                onClick={() => { handleCreateGroup() }}
                                >Create Group</LoadingButton>
                        </Grid>
                        <Grid item xs={6}>
                            <Button variant="contained" color="error" onClick={() => { handleCloseCreateDialog() }}>Cancel</Button>
                        </Grid>

                        {IsError === true && (

                            <Grid item xs={12}>
                                <Typography variajnt="h6">{GroupCRUDError && GroupCRUDError.ErrorMessage ? GroupCRUDError.ErrorMessage : "There was an error creating the group."}</Typography>
                            </Grid>
                        )}
                    </Grid>

                </DialogContent>
            </Dialog>

            <Dialog open={IsEditGroupOpen} onClose={() => { handleCloseEditDialog() }}>
                <DialogTitle>
                    <Typography variant="h4">Edit Group</Typography>
                </DialogTitle>
                <DialogContent>
                    <Grid container direction="row" alignItems="center" justifyContent="center" spacing={3}>
                        <Grid item xs={12}>
                            <TextField
                                variant="standard"
                                type="text"
                                onChange={(e) => {
                                    const value = e.target.value
                                    if (value !== "" && !ALPHA_NUMERIC_DASH_REGEX.test(value)) {
                                        return;
                                    }
                                    handleNameChange_Update(value)
                                }} value={OrganizationName_Update}
                                label="Group Name"
                                placeholder="Group Name"
                            />
                        </Grid>
                        <Grid item xs={6}>
                            <LoadingButton 
                                variant="contained" 
                                loading ={GroupCRUDStatus ==='loading'}
                                disabled={GroupCRUDStatus ==='loading'}
                                color="success" 
                                onClick={() => { handleUpdateGroup() }}
                                >Save</LoadingButton>
                        </Grid>
                        <Grid item xs={6}>
                            <Button variant="contained" color="error" onClick={() => { handleCloseEditDialog() }}>Cancel</Button>
                        </Grid>
                        {IsError === true && (

                            <Grid item xs={12}>
                                <Typography variajnt="h6">{GroupCRUDError && GroupCRUDError.ErrorMessage ? GroupCRUDError.ErrorMessage : "There was an error saving your changes"}</Typography>
                            </Grid>
                        )}
                    </Grid>

                </DialogContent>
            </Dialog>
        </Grid>
    )
}
/* 
PWD MAX LENGTH
PWD MIN LENGTH
PWD MIN LOWER CASE
PWD MIN NUMERIC
PWD MIN SPECIAL
PWD MIN UPPER CASE
THEME COLOR
THEME COLOR SECONDARY 
*/
export default OrganizationDisplay